
<template>
  <v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
    <v-dialog v-model="permitted_dialog" max-width="400px">
      <v-card>
        <v-card-text>
          <div class="text-center">
            <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
            <p>{{message}}</p>
            <v-progress-circular
              :size="70"
              :width="2"
              :value="100"
              color="error"
              class="mb-4 mr-4"
            >
              <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
            </v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
  <v-container v-else v-show="permitted != null" class="pt-0" fluid>
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>
    <v-card flat >
    <v-toolbar dense flat color="#2A353D">
      <v-toolbar-title class="white--text subtitle-1 font-weight-normal">{{heading}}</v-toolbar-title>
      <v-spacer/>
      <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
      <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>

      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        color="#81DBF6"
      ></v-progress-linear>
    </v-toolbar>
    </v-card>

    <v-alert
      class="my-2"
      dense text
      color="#2A353D"
    >
      <v-row align="center" class="mx-2">
        <v-col class="py-0">
          <v-select
            @change="getEquitiesHoldings()"
            filled rounded background-color="white" dense clearable
            hide-details
            v-model="parameters.AccountID"
            :items="Accounts.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            class="mx-1"
            :item-text="item => item.tblclient.Forename + ` ` + item.tblclient.MajorName +` - ` + item.AccountNumber"
            item-value="AccountID"
            placeholder="----"
            :rules="TextFieldRules"
            label="Account"
          ></v-select>
        </v-col>
        <v-col class="py-0">
          <v-select
            @change="getEquitiesHoldings()"
            filled rounded background-color="white" dense clearable
            hide-details
            v-model="parameters.InstrumentID"
            class="mx-1"
            :items="allCounters.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            item-text="EquityName"
            item-value="EquityID"
            placeholder="----"
            :rules="TextFieldRules"
            label="Instrument"
          ></v-select>
        </v-col>
      </v-row>
    </v-alert>

    <v-sheet class="mt-4 elevation-12">
      <v-toolbar color="white" dark dense flat>
        <v-spacer/>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="generatePDF(false)" text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "equities_holdings"
                type    = "xls"
                name    = "Equity Holdings Report.xls">
  
                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </download-excel>
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "equities_holdings"
                type    = "csv"
                name    = "Equity Holdings Report.csv">
  
                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </download-excel>
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="generatePDF(true)" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>

        <template v-slot:extension>
          <v-tabs show-arrows light color="#2A353D" v-model="tabs">
            <v-tabs-slider color="#2A353D"></v-tabs-slider>
            <v-tab v-for="counter in allCounters.filter(a => a.CheckerID != 0 && a.RejectionID == 0)" :key="counter.EquityCode" v-show="equities_holdings.map(e => e.Counter).includes(counter.EquityName)">{{counter.EquityName}}</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="tabs">
        <v-tab-item v-for="counter in allCounters.filter(a => a.CheckerID != 0 && a.RejectionID == 0)" :key="counter.EquityCode" v-show="equities_holdings.map(e => e.Counter).includes(counter.EquityName)">
          <v-data-table
            :fixed-header="true"
            :headers="headers"
            :items="equities_holdings.filter(e => e.Counter == counter.EquityName)"
            :search="search"
            :height="390"
            @current-items="getTotals"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.Percentage="{ item }">
              <spam v-if="item.Percentage">{{Number(item.Percentage).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</spam>
              <span v-else>----</span>
            </template>

            <template v-slot:item.LatestPrice="{ item }">
              <spam v-if="item.LatestPrice">{{Number(item.LatestPrice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</spam>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-sheet>
  </v-container>
</template>

<script>
import reportsService from '../services/reports.service';
import UserService from '../services/user.service';
import {mapGetters} from "vuex";
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  data () {
    return {
      parameters: {},
      equities_holdings: [],
      CurrentEquitiesHoldings: [],
      valid: true,
      loading: false,
      search: '',
      message: '',
      menu: false,
      heading: "Equities Holdings",
      menu2: false,
      permitted: null,
      tabs: null,
      permitted_dialog: true,
      headers: [
        // {
        //   text: 'Custodian Name',
        //   align: 'start',
        //   sortable: false,
        //   value: 'Custodian Name',
        //   width: 300
        // },
        // { text: 'Counter', value: 'Counter', sortable: false, width: 200 },
        { text: 'Client Name', value: 'Client Name', sortable: false, width: 300 },
        { text: 'ClientHolding', value: 'ClientHolding', sortable: false},
        { text: 'ShareInIssue', value: 'ShareInIssue', sortable: false},
        { text: 'Percentage', value: 'Percentage', sortable: false },
        { text: 'LatestPrice', value: 'LatestPrice', sortable: false, align: 'end' },
      ],
    }
  },

  computed: {
    ...mapGetters([
      "currentImage",
      "allCustodians",
      "identity",
      "allCountries",
      "allCities",
      "currentSystemDate",
      "allClientAccounts",
      "allCounters"
    ]),

    currentUser() {
      return this.$store.state.auth.user;
    },

    Accounts(){
      return this.allClientAccounts
    }
  },

  created(){
    this.parameters = {
      AccountID: 0,
      CustodianID: 0,
      InstrumentID: 0
    }
    this.loading = true;
    reportsService.getEquitiesHoldings(this.parameters)
    .then(response => {
      this.equities_holdings = response.data;
      this.loading = false
    },
    error => {
    this.message =
      (error.response && error.response.data.message) ||
      error.message ||
      error.toString();
      this.loading = false
    })
  },

  methods: {
    async getEquitiesHoldings() {
      if(this.parameters.AccountID == null || this.parameters.AccountID == ''){
        this.parameters.AccountID = 0
      }
      if(this.parameters.InstrumentID == null || this.parameters.InstrumentID == ''){
        this.parameters.InstrumentID = 0
      }
      if(this.parameters.CustodianID == null || this.parameters.CustodianID == ''){
        this.parameters.CustodianID = 0
      }
      this.loading = true;
      reportsService.getEquitiesHoldings(this.parameters)
      .then(response => {
        this.equities_holdings = response.data;
        this.loading = false
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.loading = false
      })
    },
    generatePDF(IsPrint) {
      const columns = [
        // { title: 'Custodian Name', dataKey: 'Custodian Name' },
        // { title: 'Counter', dataKey: 'Counter' },
        { title: 'Client Name', dataKey: 'Client Name' },
        { title: 'ClientHolding', dataKey: 'ClientHolding' },
        { title: 'ShareInIssue', dataKey: 'ShareInIssue' },
        { title: 'Percentage', dataKey: 'Percentage' },
        { title: 'LatestPrice', dataKey: 'LatestPrice' },
      ];

      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          var imgData = 'data:image/png;base64,'+ this.currentImage[0].data;

          doc.addImage(imgData, 'PNG', 0.5, 0.28, 1.3, 0.7);
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text(this.identity[0].OrgName, 6, 0.5);
          doc.setFontSize(6).text(this.identity[0].Phadd1, 6, 0.6);
          doc.setFontSize(6).text(this.allCities.filter(a => a.CityID == this.identity[0].PhCity).map(a => a.City)[0], 6, 0.7);
          doc.setFontSize(6).text(this.allCountries.filter(a => a.CountryId == this.identity[0].PhCountry).map(a => a.CountryName)[0], 6, 0.8);
          doc.setFontSize(6).text('email: ' + this.identity[0].OrgMail, 6, 0.9);
          doc.setFontSize(6).text('cell: ' + this.identity[0].OrgNumber, 6, 1.0);
          doc.setFontSize(10).text(this.heading, 0.5, 1.2);
          doc.setFontSize(8).text((this.parameters.AccountID > 0 ? 'Client: ' + this.Accounts.filter(a => a.AccountID == this.parameters.AccountID).map(a => a.tblclient.Forename) + ' ' + this.Accounts.filter(a => a.AccountID == this.parameters.AccountID).map(a => a.tblclient.MajorName) + '        ' : '') + (this.parameters.InstrumentID > 0 ? 'Counter: ' + this.allCounters.filter(a => a.EquityID == this.parameters.InstrumentID).map(a => a.EquityName): ''), 0.5, 1.4);
          // create a line under heading
          doc.setLineWidth(0.01).line(0.5, 1.7, 8, 1.7);
          doc.setLineWidth(0.01).line(0.5, 1.9, 8, 1.9);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      var NoOfCounters = 0

      for (var i = 0; i < this.allCounters.length; i++){
        if(this.equities_holdings.map(e => e.Counter).includes(this.allCounters[i].EquityName)){
          NoOfCounters += 1
          var title = this.allCounters[i].EquityName
          var table_body = this.equities_holdings.filter(e => e.Counter == this.allCounters[i].EquityName)
          table_body.push({'Client Name': 'TOTAL:', ClientHolding: table_body.map(t => Number(t.ClientHolding)).reduce((a, b) => a + b, 0), Percentage: table_body.map(t => Number(t.Percentage)).reduce((a, b) => a + b, 0)})
          doc.autoTable({
            columns,
            body: table_body,
            margin: { left: 0.5, top: 1.7 },
            styles: {overflow: 'linebreak',
                    fontSize: 6},
            showHeader: 'everyPage',
            beforePageContent: function(data) {
              doc.setFontSize(8);
              doc.text(title, 0.5, NoOfCounters == 1 ? data.settings.margin.top - 0.1 : doc.autoTableEndPosY() + 0.2);
              doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() + 0.28, 8, doc.autoTableEndPosY() + 0.28);
              doc.setLineWidth(0.01).line(0.5, doc.autoTableEndPosY() + 0.48, 8, doc.autoTableEndPosY() + 0.48);
            },
            theme: 'plain'
          });
        }
      }

      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Equity Holdings Report.pdf')
      }
    },
    getTotals(current){
      current.push({'Client Name': 'TOTAL:', ClientHolding: current.map(c => Number(c.ClientHolding)).reduce((a, b) => a + b, 0), Percentage: current.map(c => Number(c.Percentage)).reduce((a, b) => a + b, 0)})
    },
    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },
    validate () {
      this.$refs.form.validate()
      return this.valid
    },

    reset () {
      this.$refs.form.reset()
    },
  },

  mounted () {
    UserService.isReports().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }
}
</script>

<style scoped>
.v-btn {
  outline: none
}
</style>